class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.heading = this.mainDetailsToggle.querySelector('summary');
    this.content = this.heading.nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.heading.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    //auto bind before call
    this.bindEvents.bind(this)
    this.open.bind(this)
    this.close.bind(this)
    this.headingClicked.bind(this)

    this.checkScreenWidth()
    window.addEventListener('resize', this.checkScreenWidth.bind(this))
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  open() {
    this.mainDetailsToggle.open = true;
    this.heading.setAttribute('aria-expanded', true);
  }

  //different behaviour for larger screen devices
  checkScreenWidth() {
    if (window.innerWidth > 1260)
      this.bindEvents();
    else
      this.unbindEvents();
  }

  headingClicked() {
    window.location.href = this.dataset.href
  }

  bindEvents() {
    this.addEventListener('mouseover', this.open)
    this.addEventListener('mouseout', this.close)
    this.heading.addEventListener('click', this.headingClicked)
  }

  unbindEvents() {
    this.removeEventListener('mouseover', this.open)
    this.removeEventListener('mouseout', this.close)
    this.heading.removeEventListener('click', this.headingClicked)
  }

}

customElements.define('header-menu', HeaderMenu);
